export enum ProductTypes {
    MATERIAL = 'material',
    PRODUCT = 'product',
}
